module.exports = __webpack_public_path__ + "static/personably-task-template-card-a64800f6f5751b9df816408d2cdb53e2.svg";